module.exports = __webpack_public_path__ + "img/CS-Hybrid_Ad-Vol_1.9176c43e.jpg";